import React from 'react'
import { withRouter } from 'react-router-dom'
import { Container, Header, Wrapper } from '../../components_renew/Layout'
import bg_01 from '../../assets/theme_blue_0/event4/bg_01.jpg'
import bg_02 from '../../assets/theme_blue_0/event4/bg_02.jpg'
import c_0 from '../../assets/events/event4/c_0.png'
import c_1 from '../../assets/events/event4/c_1.png'
import c_2 from '../../assets/events/event4/c_2.png'
import c_3 from '../../assets/events/event4/c_3.png'
import { postMessage } from '../../utils'

function Item (props) {
  return <img {...props} alt=""/>
}

@withRouter
class IntegralEvent4 extends React.PureComponent {
  render () {
    return <Container>
      <Header>活动玩不停</Header>
      <Wrapper>
        <img className={'w-full'} src={bg_01} alt=""/>
        <div className={'absolute w-full grid grid-cols-2 gap-4 px-8'}>
          <Item src={c_0} onClick={this.goToWelfare}/>
          <Item src={c_1} onClick={this.goTo.bind(this, `${window.PATH.TURNTABLE}?withHeader=1`)}/>
          <Item src={c_2} onClick={this.goTo.bind(this, `${window.PATH.CARD_GAME}?withHeader=1`)}/>
          <Item src={c_3} onClick={this.goTo.bind(this, window.PATH.RED_PACKET)}/>
        </div>
        <img className={'w-full'} src={bg_02} alt=""/>
      </Wrapper>
    </Container>
  }

  goTo = (path) => {
    this.props.history.push(path)
  }
  goToWelfare = () => {
    postMessage({
      type: window.POST_TYPE.TASK_CENTER
    })
  }
}

export default IntegralEvent4